import type { FeatureNames } from "./feature-names";

/** Arabic names of the staff features and settings categories. Same keys as features.fr.ts. */
export const featuresAr: FeatureNames = {
  features: {
    SEARCH_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "البحث عن الحسابات",
    VIEW_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "عرض حساب",
    REVEAL_CONTACT_DETAILS_STAFF_FEATURE_ENABLEMENT: "إظهار رقم",
    EDIT_CUSTOMER_SETTINGS_STAFF_FEATURE_ENABLEMENT: "تعديل إعدادات عميل",
    CLAIM_CASES_STAFF_FEATURE_ENABLEMENT: "تولّي الملفات",
    REASSIGN_CASES_STAFF_FEATURE_ENABLEMENT: "إعادة إسناد الملفات",
    ACT_ON_BEHALF_STAFF_FEATURE_ENABLEMENT: "التصرف نيابةً عن عميل",
    CORRECT_ACCOUNT_DETAILS_STAFF_FEATURE_ENABLEMENT: "تصحيح بيانات حساب",
    REVIEW_VERIFICATIONS_STAFF_FEATURE_ENABLEMENT: "مراجعة عمليات التحقق",
    VIEW_ID_IMAGES_STAFF_FEATURE_ENABLEMENT: "عرض صور الهوية",
    APPROVE_PROS_STAFF_FEATURE_ENABLEMENT: "اعتماد المحترفين",
    VIEW_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "عرض المدفوعات",
    ISSUE_REFUNDS_STAFF_FEATURE_ENABLEMENT: "الاسترداد",
    ISSUE_CREDITS_STAFF_FEATURE_ENABLEMENT: "منح رصيد",
    WAIVE_FEES_STAFF_FEATURE_ENABLEMENT: "إلغاء الرسوم",
    MARK_PAYMENTS_PAID_STAFF_FEATURE_ENABLEMENT: "تحديد دفعة كمدفوعة",
    MANAGE_PLAN_PRICES_STAFF_FEATURE_ENABLEMENT: "تحديد أسعار الخطط",
    RUN_PROMOS_STAFF_FEATURE_ENABLEMENT: "إدارة العروض",
    OFFER_DISCOUNTS_STAFF_FEATURE_ENABLEMENT: "منح تخفيضات",
    MANAGE_SUBSCRIPTIONS_STAFF_FEATURE_ENABLEMENT: "تمديد اشتراك أو إنهاؤه",
    APPROVE_PAYMENT_REQUESTS_STAFF_FEATURE_ENABLEMENT: "الموافقة فوق الحد",
    RECONCILE_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "مطابقة المدفوعات",
    EXPORT_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "التصدير",
    HANDLE_REPORTS_STAFF_FEATURE_ENABLEMENT: "معالجة البلاغات",
    SET_REPORT_SEVERITY_STAFF_FEATURE_ENABLEMENT: "تحديد خطورة بلاغ",
    SUSPEND_PENDING_INVESTIGATION_STAFF_FEATURE_ENABLEMENT: "الإيقاف المؤقت",
    ISSUE_VERDICTS_STAFF_FEATURE_ENABLEMENT: "إصدار حكم",
    BAN_PERMANENTLY_STAFF_FEATURE_ENABLEMENT: "الحظر النهائي",
    HANDLE_APPEALS_STAFF_FEATURE_ENABLEMENT: "معالجة الطعون",
    REFER_TO_POLICE_STAFF_FEATURE_ENABLEMENT: "الإحالة إلى الشرطة",
    SHARE_DATA_WITH_POLICE_STAFF_FEATURE_ENABLEMENT: "مشاركة البيانات مع الشرطة",
    PLACE_LEGAL_HOLDS_STAFF_FEATURE_ENABLEMENT: "تجميد الأدلة",
    MODERATE_REVIEWS_STAFF_FEATURE_ENABLEMENT: "الإشراف على التقييمات",
    SEND_SMS_STAFF_FEATURE_ENABLEMENT: "إرسال رسائل نصية",
    SEND_BULK_SMS_STAFF_FEATURE_ENABLEMENT: "إرسال رسائل نصية جماعية",
    EDIT_SMS_TEMPLATES_STAFF_FEATURE_ENABLEMENT: "تعديل قوالب الرسائل النصية",
    MANAGE_APP_FEATURES_STAFF_FEATURE_ENABLEMENT: "إدارة ميزات التطبيق",
    EDIT_RULES_STAFF_FEATURE_ENABLEMENT: "تعديل القواعد",
    EDIT_PRICING_STAFF_FEATURE_ENABLEMENT: "تعديل الأسعار",
    EDIT_CATEGORIES_STAFF_FEATURE_ENABLEMENT: "تعديل المهن",
    INVITE_STAFF_STAFF_FEATURE_ENABLEMENT: "الدعوة إلى الفريق",
    DEACTIVATE_STAFF_STAFF_FEATURE_ENABLEMENT: "تعطيل عضو",
    END_STAFF_SESSIONS_STAFF_FEATURE_ENABLEMENT: "إنهاء الجلسات",
    MANAGE_TEAMS_STAFF_FEATURE_ENABLEMENT: "إدارة الفرق",
    MANAGE_ROLES_STAFF_FEATURE_ENABLEMENT: "إدارة الأدوار",
    MANAGE_ACTION_ENABLEMENTS_STAFF_FEATURE_ENABLEMENT: "إدارة تفعيلات الإجراءات",
    ASSIGN_ROLES_STAFF_FEATURE_ENABLEMENT: "إسناد الأدوار",
    MANAGE_LEADS_STAFF_FEATURE_ENABLEMENT: "المبيعات والنمو",
    VIEW_MARKETPLACE_STAFF_FEATURE_ENABLEMENT: "عمليات السوق",
    MANAGE_HUMAN_RESOURCES_STAFF_FEATURE_ENABLEMENT: "الموارد البشرية",
    VIEW_AUDIT_LOG_STAFF_FEATURE_ENABLEMENT: "قراءة سجل التدقيق",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_FEATURE_ENABLEMENT: "عرض القيم الحساسة",
    VIEW_HEALTH_DASHBOARD_STAFF_FEATURE_ENABLEMENT: "عرض لوحة المتابعة",
  },
  /** The permissions that sit on those features (ADR-0019), by settingId. */
  permissions: {
    ISSUE_REFUND_STAFF_PERMISSION: "إصدار استرداد",
    SETTLE_REFUND_STAFF_PERMISSION: "تسوية استرداد",
    ISSUE_CREDIT_STAFF_PERMISSION: "إصدار رصيد",
    WAIVE_FEE_STAFF_PERMISSION: "إلغاء رسم",
    REPLY_TO_CUSTOMER_STAFF_PERMISSION: "الرد على عميل",
    CLOSE_CASE_STAFF_PERMISSION: "إغلاق ملف",
  },
  /** Customer features (Fonctionnalités), by settingId. */
  customerFeatures: {
    SEARCH_PROS_USER_FEATURE_ENABLEMENT: "البحث عن محترفين",
    NEARBY_PROS_USER_FEATURE_ENABLEMENT: "محترفون بالقرب منك",
    REQUEST_PRO_USER_FEATURE_ENABLEMENT: "طلب محترف",
    POST_OPEN_JOB_USER_FEATURE_ENABLEMENT: "نشر طلب مفتوح",
    JOB_PHOTOS_USER_FEATURE_ENABLEMENT: "صور في الطلب",
    SELECT_QUOTE_USER_FEATURE_ENABLEMENT: "اختيار عرض سعر",
    LEAVE_REVIEWS_USER_FEATURE_ENABLEMENT: "ترك تقييم",
    REQUEST_CALLBACK_USER_FEATURE_ENABLEMENT: "طلب معاودة الاتصال",
    SAVE_FAVORITE_PROS_USER_FEATURE_ENABLEMENT: "المحترفون المفضلون",
    REBOOK_PRO_USER_FEATURE_ENABLEMENT: "إعادة الحجز لدى محترف",
    SHARE_PRO_PROFILE_USER_FEATURE_ENABLEMENT: "مشاركة ملف محترف",
    SCHEDULE_JOB_USER_FEATURE_ENABLEMENT: "جدولة طلب",
    URGENT_JOB_USER_FEATURE_ENABLEMENT: "طلب عاجل",
    BECOME_PRO_USER_FEATURE_ENABLEMENT: "التحول إلى محترف",
    LEAD_PREFERENCES_USER_FEATURE_ENABLEMENT: "تفضيلات الفرص",
    EDIT_RATES_USER_FEATURE_ENABLEMENT: "تعديل الأسعار",
    BROWSE_OPEN_JOBS_USER_FEATURE_ENABLEMENT: "تصفح الطلبات المفتوحة",
    QUOTE_JOBS_USER_FEATURE_ENABLEMENT: "عروض أسعار على الطلبات",
    PRO_SUBSCRIPTIONS_USER_FEATURE_ENABLEMENT: "اشتراكات المحترفين",
    SUBMIT_VERIFICATION_USER_FEATURE_ENABLEMENT: "إرسال التحقق",
    PAUSE_LEADS_USER_FEATURE_ENABLEMENT: "إيقاف الفرص مؤقتًا",
    PORTFOLIO_PHOTOS_USER_FEATURE_ENABLEMENT: "صور الأعمال",
    QUICK_REPLIES_USER_FEATURE_ENABLEMENT: "ردود سريعة",
    ACTIVITY_PAGE_USER_FEATURE_ENABLEMENT: "صفحة النشاط",
    DECLARE_JOB_OUTCOME_USER_FEATURE_ENABLEMENT: "الإبلاغ عن نتيجة طلب",
    LEAD_NOTIFICATIONS_USER_FEATURE_ENABLEMENT: "فرص عبر الإشعارات",
    SMS_LEADS_USER_FEATURE_ENABLEMENT: "فرص عبر الرسائل النصية",
    JOB_REMINDERS_USER_FEATURE_ENABLEMENT: "تذكيرات الطلبات",
    SWITCH_MODE_USER_FEATURE_ENABLEMENT: "التبديل بين عميل ومحترف",
    MESSAGING_USER_FEATURE_ENABLEMENT: "المراسلة",
    SEND_PHOTOS_USER_FEATURE_ENABLEMENT: "إرسال الصور",
    SHARE_LOCATION_USER_FEATURE_ENABLEMENT: "مشاركة الموقع",
    CHANGE_PHONE_USER_FEATURE_ENABLEMENT: "تغيير رقم الهاتف",
    CHANGE_EMAIL_USER_FEATURE_ENABLEMENT: "تغيير البريد الإلكتروني",
    CONTACT_US_USER_FEATURE_ENABLEMENT: "اتصل بنا",
    CREATE_CLIENT_PROFILE_USER_FEATURE_ENABLEMENT: "إنشاء ملف عميل",
    REPORT_USER_USER_FEATURE_ENABLEMENT: "الإبلاغ عن شخص",
    BLOCK_USER_USER_FEATURE_ENABLEMENT: "حظر شخص",
    APPEAL_DECISION_USER_FEATURE_ENABLEMENT: "الطعن في قرار",
    SECURITY_ACTIVITY_USER_FEATURE_ENABLEMENT: "نشاط الأمان",
    REFER_FRIENDS_USER_FEATURE_ENABLEMENT: "دعوة الأصدقاء",
  },
  /** Every action, so the audit log names what was done instead of its id (#185). */
  actions: {
    SIGN_UP_USER_ACTION: "التسجيل",
    SIGN_IN_USER_ACTION: "تسجيل الدخول",
    SIGN_OUT_USER_ACTION: "تسجيل الخروج",
    UPDATE_PERSONAL_INFO_USER_ACTION: "تحديث البيانات الشخصية",
    CHANGE_PHONE_USER_ACTION: "تغيير رقم الهاتف",
    CHANGE_EMAIL_USER_ACTION: "تغيير البريد الإلكتروني",
    CHANGE_PASSWORD_USER_ACTION: "تغيير كلمة المرور",
    SWITCH_MODE_USER_ACTION: "التبديل بين عميل ومحترف",
    CREATE_CLIENT_PROFILE_USER_ACTION: "إنشاء ملف عميل",
    UPDATE_SETTING_USER_ACTION: "تعديل إعداد",
    VIEW_SECURITY_ACTIVITY_USER_ACTION: "عرض نشاط الأمان",
    REFER_FRIEND_USER_ACTION: "دعوة صديق",
    DELETE_ACCOUNT_USER_ACTION: "حذف الحساب",
    BECOME_PRO_USER_ACTION: "التحول إلى محترف",
    SUBMIT_VERIFICATION_USER_ACTION: "إرسال وثيقة هوية للتحقق",
    UPDATE_PRO_PROFILE_USER_ACTION: "تحديث ملف المحترف",
    UPDATE_RATES_USER_ACTION: "تحديث الأسعار",
    ADD_PORTFOLIO_PHOTO_USER_ACTION: "إضافة صورة عمل",
    REMOVE_PORTFOLIO_PHOTO_USER_ACTION: "حذف صورة عمل",
    UPDATE_LEAD_PREFERENCES_USER_ACTION: "تحديث تفضيلات الفرص",
    PAUSE_LEADS_USER_ACTION: "إيقاف الفرص مؤقتًا",
    RESUME_LEADS_USER_ACTION: "استئناف الفرص",
    VIEW_OPEN_JOBS_USER_ACTION: "عرض الطلبات المفتوحة",
    VIEW_ACTIVITY_USER_ACTION: "عرض النشاط",
    REQUEST_PRO_USER_ACTION: "طلب محترف",
    POST_OPEN_JOB_USER_ACTION: "نشر طلب مفتوح",
    REBOOK_PRO_USER_ACTION: "إعادة الحجز لدى محترف",
    UPDATE_JOB_USER_ACTION: "تحديث طلب",
    ADD_JOB_PHOTOS_USER_ACTION: "إضافة صور إلى طلب",
    SCHEDULE_JOB_USER_ACTION: "جدولة طلب",
    MARK_JOB_URGENT_USER_ACTION: "تحديد طلب كعاجل",
    SELECT_QUOTE_USER_ACTION: "اختيار عرض سعر",
    CANCEL_JOB_USER_ACTION: "إلغاء طلب",
    SUBMIT_QUOTE_USER_ACTION: "إرسال عرض سعر",
    UPDATE_QUOTE_USER_ACTION: "تحديث عرض سعر",
    WITHDRAW_QUOTE_USER_ACTION: "سحب عرض سعر",
    ACCEPT_JOB_USER_ACTION: "قبول طلب",
    DECLINE_JOB_USER_ACTION: "الاعتذار عن طلب",
    DECLARE_JOB_OUTCOME_USER_ACTION: "الإبلاغ عن نتيجة طلب",
    SEARCH_PROS_USER_ACTION: "البحث عن محترفين",
    SEARCH_PROS_NEARBY_USER_ACTION: "البحث عن محترفين قريبين",
    VIEW_PRO_PROFILE_USER_ACTION: "عرض ملف محترف",
    SAVE_FAVORITE_PRO_USER_ACTION: "حفظ محترف مفضل",
    REMOVE_FAVORITE_PRO_USER_ACTION: "إزالة محترف مفضل",
    SHARE_PRO_PROFILE_USER_ACTION: "مشاركة ملف محترف",
    OPEN_CONVERSATION_USER_ACTION: "فتح محادثة",
    SEND_MESSAGE_USER_ACTION: "إرسال رسالة",
    SEND_PHOTO_USER_ACTION: "إرسال صورة",
    SHARE_LOCATION_USER_ACTION: "مشاركة موقع",
    READ_MESSAGES_USER_ACTION: "قراءة الرسائل",
    SAVE_QUICK_REPLY_USER_ACTION: "حفظ رد سريع",
    LEAVE_REVIEW_USER_ACTION: "ترك تقييم",
    SUBSCRIBE_TO_PLAN_USER_ACTION: "الاشتراك في خطة",
    CANCEL_SUBSCRIPTION_USER_ACTION: "إلغاء التجديد",
    RESUME_SUBSCRIPTION_USER_ACTION: "استئناف التجديد",
    CHANGE_PLAN_USER_ACTION: "تغيير الخطة",
    PAY_FEE_USER_ACTION: "دفع رسم",
    CONTACT_SUPPORT_USER_ACTION: "التواصل مع الدعم",
    REQUEST_CALLBACK_USER_ACTION: "طلب معاودة الاتصال",
    REPORT_USER_USER_ACTION: "الإبلاغ عن شخص",
    BLOCK_USER_USER_ACTION: "حظر شخص",
    UNBLOCK_USER_USER_ACTION: "رفع الحظر عن شخص",
    APPEAL_DECISION_USER_ACTION: "الطعن في قرار",
    CREATE_EXPERIMENT_STAFF_ACTION: "بدء تجربة",
    MOVE_EXPERIMENT_STAFF_ACTION: "توسيع تجربة أو إيقافها",
    ADD_LEAD_STAFF_ACTION: "إضافة عميل محتمل",
    MOVE_LEAD_STAFF_ACTION: "دفع عميل محتمل",
    CREATE_CAMPAIGN_STAFF_ACTION: "إعداد حملة",
    SEND_CAMPAIGN_STAFF_ACTION: "إرسال حملة",
    OPEN_INCIDENT_STAFF_ACTION: "فتح عُطل",
    UPDATE_INCIDENT_STAFF_ACTION: "تحديث عُطل",
    VIEW_MARKETPLACE_STAFF_ACTION: "الاطلاع على حال السوق",
    VIEW_MARKETPLACE_JOB_STAFF_ACTION: "الاطلاع على طلب",
    SIGN_IN_STAFF_ACTION: "تسجيل الدخول إلى لوحة التحكم",
    SIGN_OUT_STAFF_ACTION: "تسجيل الخروج من لوحة التحكم",
    SET_PASSWORD_STAFF_ACTION: "تعيين كلمة مرور لوحة التحكم",
    UPDATE_STAFF_SETTING_STAFF_ACTION: "تعديل إعداد في لوحة التحكم",
    SEARCH_ACCOUNTS_STAFF_ACTION: "البحث عن الحسابات",
    VIEW_ACCOUNT_STAFF_ACTION: "عرض حساب",
    REVEAL_CONTACT_DETAILS_STAFF_ACTION: "إظهار رقم هاتف",
    EDIT_CUSTOMER_SETTING_STAFF_ACTION: "تعديل إعداد عميل",
    CORRECT_ACCOUNT_DETAILS_STAFF_ACTION: "تصحيح بيانات حساب",
    CLAIM_CASE_STAFF_ACTION: "تولّي ملف",
    LOG_CALL_STAFF_ACTION: "تسجيل مكالمة",
    REPLY_TO_CASE_STAFF_ACTION: "الرد على عميل",
    ADD_CASE_NOTE_STAFF_ACTION: "إضافة ملاحظة داخلية",
    CLOSE_CASE_STAFF_ACTION: "إغلاق ملف",
    REASSIGN_CASE_STAFF_ACTION: "إعادة إسناد ملف",
    LINK_CASE_CUSTOMER_STAFF_ACTION: "ربط عميل بملف",
    START_ON_BEHALF_SESSION_STAFF_ACTION: "بدء التصرف نيابةً عن عميل",
    END_ON_BEHALF_SESSION_STAFF_ACTION: "إنهاء التصرف نيابةً عن عميل",
    VIEW_VERIFICATION_STAFF_ACTION: "عرض عملية تحقق",
    APPROVE_VERIFICATION_STAFF_ACTION: "اعتماد عملية تحقق",
    REJECT_VERIFICATION_STAFF_ACTION: "رفض عملية تحقق",
    VIEW_ID_IMAGES_STAFF_ACTION: "عرض صور الهوية",
    APPROVE_PRO_STAFF_ACTION: "اعتماد محترف",
    REJECT_PRO_STAFF_ACTION: "رفض محترف",
    VIEW_PAYMENTS_STAFF_ACTION: "عرض المدفوعات",
    ISSUE_REFUND_STAFF_ACTION: "إصدار استرداد",
    ISSUE_CREDIT_STAFF_ACTION: "إصدار رصيد",
    WAIVE_FEE_STAFF_ACTION: "إلغاء رسم",
    MARK_PAYMENT_PAID_STAFF_ACTION: "تحديد رسم كمدفوع",
    APPROVE_PAYMENT_REQUEST_STAFF_ACTION: "الموافقة على طلب",
    REJECT_PAYMENT_REQUEST_STAFF_ACTION: "رفض طلب",
    SETTLE_REFUND_STAFF_ACTION: "تسوية استرداد",
    SET_PLAN_PRICE_STAFF_ACTION: "تحديد سعر خطة",
    CREATE_PROMO_STAFF_ACTION: "إنشاء عرض ترويجي",
    END_PROMO_STAFF_ACTION: "إنهاء عرض ترويجي",
    CREATE_DISCOUNT_STAFF_ACTION: "إنشاء تخفيض",
    END_DISCOUNT_STAFF_ACTION: "إنهاء تخفيض",
    EXTEND_SUBSCRIPTION_STAFF_ACTION: "تمديد اشتراك",
    END_SUBSCRIPTION_STAFF_ACTION: "إنهاء اشتراك",
    RECONCILE_PAYMENTS_STAFF_ACTION: "مطابقة المدفوعات",
    EXPORT_PAYMENTS_STAFF_ACTION: "تصدير المدفوعات",
    OPEN_SAFETY_REPORT_STAFF_ACTION: "فتح بلاغ أمان",
    ADD_REPORT_EVIDENCE_STAFF_ACTION: "إضافة أدلة إلى بلاغ",
    SET_REPORT_SEVERITY_STAFF_ACTION: "تحديد خطورة بلاغ",
    SUSPEND_PENDING_INVESTIGATION_STAFF_ACTION: "إيقاف حساب بانتظار التحقيق",
    LIFT_SUSPENSION_STAFF_ACTION: "رفع إيقاف",
    ISSUE_VERDICT_STAFF_ACTION: "إصدار حكم",
    BAN_PERMANENTLY_STAFF_ACTION: "حظر حساب نهائيًا",
    DECIDE_APPEAL_STAFF_ACTION: "البت في طعن",
    REFER_TO_POLICE_STAFF_ACTION: "إحالة ملف إلى الشرطة",
    SHARE_DATA_WITH_POLICE_STAFF_ACTION: "مشاركة البيانات مع الشرطة",
    PLACE_LEGAL_HOLD_STAFF_ACTION: "فرض تجميد للأدلة",
    RELEASE_LEGAL_HOLD_STAFF_ACTION: "رفع تجميد الأدلة",
    HIDE_REVIEW_STAFF_ACTION: "إخفاء تقييم",
    RESTORE_REVIEW_STAFF_ACTION: "استعادة تقييم",
    SEND_SMS_STAFF_ACTION: "إرسال رسالة نصية",
    SEND_BULK_SMS_STAFF_ACTION: "إرسال رسالة نصية إلى عدة أشخاص",
    EDIT_SMS_TEMPLATE_STAFF_ACTION: "تعديل قالب رسالة نصية",
    SET_USER_FEATURE_ENABLEMENT_STAFF_ACTION: "تفعيل ميزة عميل أو تعطيلها",
    CREATE_RULE_VERSION_STAFF_ACTION: "تعديل قاعدة من قواعد الشركة",
    EDIT_PRICING_STAFF_ACTION: "تعديل شرائح الرسوم",
    EDIT_CATEGORIES_STAFF_ACTION: "تعديل المهن",
    INVITE_STAFF_STAFF_ACTION: "دعوة عضو في الفريق",
    DEACTIVATE_STAFF_STAFF_ACTION: "تعطيل عضو في الفريق",
    REACTIVATE_STAFF_STAFF_ACTION: "إعادة تفعيل عضو في الفريق",
    END_STAFF_SESSION_STAFF_ACTION: "إنهاء جلسات عضو في الفريق",
    REQUEST_PERMISSION_STAFF_ACTION: "طلب إذن",
    DECIDE_PERMISSION_REQUEST_STAFF_ACTION: "الرد على طلب إذن",
    UPDATE_ACTION_ENABLEMENT_STAFF_ACTION: "تعديل تفعيل إجراء",
    REQUEST_TIME_OFF_STAFF_ACTION: "طلب إجازة",
    DECIDE_TIME_OFF_STAFF_ACTION: "البتّ في طلب إجازة",
    SET_EMPLOYMENT_STAFF_ACTION: "تعديل ملف التوظيف",
    OPEN_JOB_STAFF_ACTION: "فتح وظيفة",
    EDIT_JOB_STAFF_ACTION: "تعديل وظيفة",
    MOVE_CANDIDATE_STAFF_ACTION: "تقديم مرشّح",
    OPEN_PAYROLL_STAFF_ACTION: "فتح شهر رواتب",
    EDIT_PAYROLL_LINE_STAFF_ACTION: "تعليق أو تحرير سطر راتب",
    CLOSE_PAYROLL_STAFF_ACTION: "إغلاق شهر رواتب",
    OPEN_REVIEW_CYCLE_STAFF_ACTION: "فتح دورة تقييم",
    WRITE_REVIEW_STAFF_ACTION: "كتابة تقييم",
    EDIT_COURSE_STAFF_ACTION: "إضافة أو تعديل دورة",
    ENROL_IN_COURSE_STAFF_ACTION: "التسجيل في دورة",
    CREATE_TEAM_STAFF_ACTION: "إنشاء فريق",
    EDIT_TEAM_STAFF_ACTION: "تعديل فريق",
    SET_TEAM_MEMBERSHIP_STAFF_ACTION: "تحديد أعضاء الفريق",
    CREATE_ROLE_STAFF_ACTION: "إنشاء دور",
    EDIT_ROLE_STAFF_ACTION: "تعديل دور",
    SET_STAFF_PERMISSION_STAFF_ACTION: "منح إذن أو سحبه",
    SET_STAFF_FEATURE_ENABLEMENT_STAFF_ACTION: "منح ميزة أو سحبها",
    ASSIGN_ROLE_STAFF_ACTION: "إسناد دور",
    REMOVE_ROLE_STAFF_ACTION: "إزالة دور",
    VIEW_AUDIT_LOG_STAFF_ACTION: "قراءة سجل التدقيق",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_ACTION: "عرض قيم التدقيق الحساسة",
    VIEW_HEALTH_DASHBOARD_STAFF_ACTION: "عرض لوحة المتابعة",
    EXPIRE_JOB_SYSTEM_ACTION: "انتهاء صلاحية طلب لم يرد عليه أحد",
    EXPIRE_QUOTE_SYSTEM_ACTION: "انتهاء صلاحية عرض سعر",
    CLOSE_OTHER_QUOTES_SYSTEM_ACTION: "إغلاق عروض الأسعار الأخرى",
    OPEN_CONVERSATION_ON_QUOTE_SYSTEM_ACTION: "فتح محادثة حول عرض سعر",
    NOTIFY_USER_SYSTEM_ACTION: "إرسال إشعار",
    NOTIFY_NEW_LEAD_SYSTEM_ACTION: "إشعار محترف بفرصة جديدة",
    SEND_LEAD_SMS_SYSTEM_ACTION: "إرسال فرصة عبر رسالة نصية",
    NOTIFY_JOB_REMINDER_SYSTEM_ACTION: "إرسال تذكير بطلب",
    CONFIRM_FEE_PAYMENT_SYSTEM_ACTION: "تأكيد دفع رسم",
    FAIL_FEE_PAYMENT_SYSTEM_ACTION: "تسجيل فشل دفع رسم",
    ACTIVATE_SUBSCRIPTION_SYSTEM_ACTION: "تفعيل اشتراك",
    SUSPEND_SUBSCRIPTION_SYSTEM_ACTION: "تعليق اشتراك",
    RENEW_SUBSCRIPTION_SYSTEM_ACTION: "تجديد اشتراك",
    EXPIRE_SUBSCRIPTION_SYSTEM_ACTION: "إنهاء اشتراك منتهٍ",
    REMIND_SUBSCRIPTION_EXPIRY_SYSTEM_ACTION: "تذكير محترف بأن خطته على وشك الانتهاء",
    EXPIRE_SETTING_VALUE_SYSTEM_ACTION: "انتهاء صلاحية قيمة إعداد",
    DELETE_ID_IMAGES_SYSTEM_ACTION: "حذف صور الهوية",
    FLAG_BANNED_DOCUMENT_SYSTEM_ACTION: "وضع علامة على وثيقة محظورة",
    SUSPEND_ON_CRITICAL_REPORT_SYSTEM_ACTION: "الإيقاف عند بلاغ حرج",
  },
  /** The settings a person chooses for themselves, by settingId. */
  settings: {
    THEME_USER_SETTING: "السمة",
    COLOR_VIBE_USER_SETTING: "اللون",
    LANGUAGE_USER_SETTING: "اللغة",
    LOW_DATA_MODE_USER_SETTING: "وضع تقليل البيانات",
    NEW_LEAD_NOTIFICATION_USER_SETTING: "إشعاري بالفرص الجديدة",
    QUOTE_RECEIVED_NOTIFICATION_USER_SETTING: "إشعاري عند وصول عرض سعر",
    NEW_LEAD_SMS_USER_SETTING: "إرسال الفرص الجديدة عبر رسالة نصية",
    QUOTE_RECEIVED_SMS_USER_SETTING: "إرسال عرض سعر عبر رسالة نصية",
    LEAD_TRADES_USER_SETTING: "المهن التي أريد فرصًا فيها",
    LEAD_SERVICE_AREA_USER_SETTING: "أين أعمل",
    LEAD_RADIUS_USER_SETTING: "إلى أي مسافة أتنقل",
    LEAD_DAYS_USER_SETTING: "الأيام التي أقبل فيها العمل",
    URGENT_JOBS_USER_SETTING: "الطلبات العاجلة",
    CONSOLE_THEME_STAFF_SETTING: "سمة لوحة التحكم",
    CONSOLE_LANGUAGE_STAFF_SETTING: "لغة لوحة التحكم",
  },
  /** The grid's section titles. */
  categories: {
    appearance: "المظهر",
    notifications: "الإشعارات",
    leads: "الفرص",
    discovery: "البحث",
    jobs: "الطلبات",
    profile: "الملف الشخصي",
    accounts: "الحسابات",
    support: "الملفات",
    onBehalf: "نيابةً عن عميل",
    onboarding: "التحقق",
    payments: "المدفوعات",
    safety: "الثقة والأمان",
    messaging: "الرسائل",
    configuration: "الإعدادات العامة",
    staff: "الفريق والوصول",
    audit: "التدقيق",
  },
};
